module.exports = __webpack_public_path__ + "assets/media/bf1_mian_theme.1a70392a.mp3";